
/**
 * 대화 정보 업데이트 요청
 */
export type UpdateConversationBody = {
  /**
   * 변경할 대화 제목
   * @nullable
   */
  title?: string | null;
};
